import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=5adf8a2e&scoped=true&"
import script from "./OrderCreate.vue?vue&type=script&lang=ts&"
export * from "./OrderCreate.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCreate.vue?vue&type=style&index=0&id=5adf8a2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adf8a2e",
  null
  
)

export default component.exports